module.exports = __webpack_public_path__ + "52280e55c43d49a6f2208b306a9181b2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-7.png
// module id = 1720
// module chunks = 0